import { makeStyles } from '@map/theme';
import { InputAdornment } from '@mui/material';
import useFlipState from '@shared/hooks/useFlipState';
import Button from '@ui/Button';
import EyeHiddenIcon from '@ui/Icon/library/EyeHiddenIcon';
import EyeIcon from '@ui/Icon/library/EyeIcon';
import { ComponentProps, useRef } from 'react';
import TextFormField from './TextFormField';

const useStyles = makeStyles(({}) => ({
  msEdgeOverride: {
    '&::-ms-reveal': {
      display: 'none',
    },
  },
}));

type Props = Omit<ComponentProps<typeof TextFormField>, 'type'>;
const NewPasswordField: FC<Props> = ({ ...restProps }) => {
  const passwordRef = useRef<HTMLInputElement>();
  const [isVisible, toggleVisible] = useFlipState(false);
  const { classes, cx } = useStyles();

  const handleClick = () => {
    const cursorPosition = passwordRef.current?.selectionStart || 0;
    toggleVisible();
    if (passwordRef.current) {
      passwordRef.current.focus();
      setTimeout(
        // The setSelectionRange function doesn't work outside the setTimeout :(
        () => passwordRef.current?.setSelectionRange(cursorPosition, cursorPosition),
        0,
      );
    }
  };

  return (
    <TextFormField
      {...restProps}
      type={isVisible ? 'text' : 'password'}
      inputProps={{
        className: cx(classes.msEdgeOverride, restProps.inputProps?.className),
        ref: passwordRef,
      }}
      InputProps={{
        ...restProps.InputProps,
        endAdornment: (
          <InputAdornment position="end">
            <Button
              size="medium"
              variant="tertiary"
              tabIndex={-1}
              ariaLabelIntlKey="common.toggle_password_visibility"
              onClick={handleClick}
            >
              {isVisible ? <EyeIcon /> : <EyeHiddenIcon />}
            </Button>
          </InputAdornment>
        ),
      }}
    />
  );
};

export default NewPasswordField;
